module.exports = __webpack_public_path__ + "media/images/front/post_no_image-1ddf4c43d16553d7db84e35497bf97b5.png";